const masonryCarouselItemMarketingConverter = (item)=>{
    const { title ='' , image ={
        src: ''
    } , link ={
        href: ''
    } , description  } = item.data ?? item.props ?? {};
    return {
        title,
        description,
        image,
        link
    };
};
export const masonryCarouselMarketingConverter = (masonry)=>{
    const props = masonry.data ?? masonry.props ?? {};
    const heading = props.heading?.props ?? props.heading?.data ?? {};
    const title = {
        content: heading?.title ?? ''
    };
    const subtitle = {
        content: heading?.subtitle ?? ''
    };
    const skinMasonry = props.skin_masonry?.toString() ?? '3';
    const items = props.items?.map(masonryCarouselItemMarketingConverter) ?? [];
    return {
        ...masonry,
        name: masonry.name ?? 'masonry',
        props: {
            title,
            subtitle,
            skin_masonry: skinMasonry,
            items,
            cardTitleVariant: 'secondary',
            backgroundVariant: 'none'
        }
    };
};

//# sourceMappingURL=converter.js.map